import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FormAnRFolder from 'generic/components/forms/FormAnRFolder';
import GlobalLoading from 'generic/components/pages/GlobalLoading';
import { simpleToExpertQuery } from 'generic/utils/anrUtils';
import { emailsAsArrayFromAutocomplete } from 'generic/utils/qesUtils';
import { saveAnRFolder } from 'generic/core/anr/actions';
import { testSettings } from 'generic/api/anr';
import { snackActions } from 'generic/utils/snackbar';
import { CONSTANTS } from 'generic/core/constants';

const { LANG_MAPPING } = CONSTANTS;

const SettingsContainer = () => {
  const user = useSelector((state) => state.anr.user);
  const editFolderLoading = useSelector((state) => state.anr.editFolderLoading);
  const saveFolderLoading = useSelector((state) => state.anr.saveFolderLoading);
  const folder = useSelector((state) => state.anr.editFolder);
  const folders = useSelector((state) => state.anr.folders);
  const lang = useSelector((state) => state.config.user.langue);
  const userMail = useSelector((state) => state.config.user.email);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    view,
  } = useParams();

  const optionsRoots = [];

  const setOptionsRoots = (foldersTree) => {
    _.map(foldersTree, (folderTree) => {
      if (folderTree.children) {
        const optionTitle = `${folderTree.title} / `;
        if (!optionsRoots.includes(optionTitle)) {
          optionsRoots.push(optionTitle);
        }
        setOptionsRoots(folderTree.children);
      }
    });
  };

  setOptionsRoots(_.flatten(folders));

  if (_.isEmpty(folder) && view !== 'new') {
    if (editFolderLoading) {
      return <GlobalLoading />;
    }
    return null;
  }

  const processQueryValue = (values) => {
    const alteredValues = { ..._.omit(values, ['queryMust', 'queryMay', 'queryMustNot']) };
    if (!values.expert_mode) {
      const queries = {
        queryMust: values.queryMust,
        queryMay: values.queryMay,
        queryMustNot: values.queryMustNot,
      };
      alteredValues.query = simpleToExpertQuery(queries);
    }
    return alteredValues;
  };

  const handleSubmit = (values) => {
    const alteredValues = processQueryValue(values);
    const params = emailsAsArrayFromAutocomplete(['alerts_emails'], alteredValues);
    dispatch(saveAnRFolder(params));
  };

  const handleTestSettings = (values) => {
    const alteredValues = processQueryValue(values);

    try {
      testSettings({ bodyItems: { ...alteredValues } }).then((results) => {
        if (_.isEmpty(_.get(results.response.message, 'error'))) {
          if (results.nb_articles === 0) {
            snackActions.warning(t('anr.no_articles_from_test'));
          } else {
            snackActions.info(`${results.nb_articles} ${t('anr.articles_from_test')}`);
          }
        } else {
          snackActions.error(`${results.response.message.error} : ${results.response.message.info}`);
        }
      });
    } catch (response) {
      snackActions.error(t('form.errors.error_from_test'));
    }
  };

  let alteredFolder = { ...folder };
  // Si on duplique un dossier, on va virer l'id et modifier le titre
  if (view === 'copy') {
    alteredFolder = _.omitBy(alteredFolder, (value, key) => (
      key === 'id'
    ));
    alteredFolder.title = `${alteredFolder.title} (${t('anr.copy')})`;
  } else if (view === 'new') {
    alteredFolder.langs = [LANG_MAPPING[lang]];
  }
  return (
    <FormAnRFolder
      folder={alteredFolder}
      onSubmit={handleSubmit}
      onTestSettings={handleTestSettings}
      optionsRoots={optionsRoots}
      loading={saveFolderLoading}
      user={user}
      userMail={userMail}
      view={view}
    />
  );
};

export default SettingsContainer;
